export default class formConfig {
  // 项目信息
  static configList() {
    return [
      {
        title: "基本信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "职务：",
            value: "duty",
            type: "input",
            width: "100%",
            maxlength: 300,
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "姓名：",
            value: "name",
            type: "input",
            width: "100%",
            maxlength: 20,
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "职称：",
            value: "positionalTitles",
            type: "input",
            width: "100%",
            maxlength: 300,
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
        ]
      },
      {
        title: "执业或职业资格证明",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "证书名称：",
            value: "certificateName",
            type: "input",
            width: "100%",
            maxlength: 300,
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "级别：",
            value: "level",
            type: "input",
            width: "100%",
            maxlength: 100,
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "证号：",
            value: "number",
            type: "input",
            width: "100%",
            maxlength: 100,
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "专业：",
            value: "professional",
            type: "input",
            width: "100%",
            maxlength: 300,
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
        ]
      },
    ];
  }
}
